import { createSelector } from 'reselect';

export const getHdmsStoreDetails = createSelector(
  (state) => state.store,
  (store) => store,
);

export const getHdmsStoreIdSelector = createSelector(
  getHdmsStoreDetails,
  (storeInfo) => Number(storeInfo?.storeInfo?.storeId) || '121'
);
